import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MultiSelect from "../extra/MultiSelect";
import CountrySelect from "../extra/CountrySelect";

export default function Form({
    title,
    companies = [],
    projects = [],
    users = [],
    defaultValues = {},
    onSubmit = () => { },
    onChange = () => { },
    back = () => { },
}) {
    const {
        register,
        handleSubmit,
        control,
        watch,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        defaultValues,
        mode: "all",
        shouldFocusError: true,
    });


    const [open, setOpen] = useState(false);
    const companyValue = watch("company");
    const isActive = watch("is_active");
    const selectedProjects = watch("project"); // get current value
    useEffect(() => {
        // Manually register the field and set default value
        register("project");
        setValue("project", defaultValues.projects || [], { shouldValidate: true });
    }, [register, setValue, defaultValues.projects]);
    useEffect(() => {
        onChange("company", companyValue);
    }, [companyValue]);

    const handleFormSubmit = (data) => {
        console.log("data submit", data);
        const proj = data.project || [];
        if (!proj.length) {
            setError("project", {
                type: "required",
                // message: "Please select at least one project",
            });
            return; // stop submission
        }
        onSubmit(data);
    };

    const booleanFields = [
        { name: "can_view_timelapse", label: "Access timelapse camera", watch: watch("can_view_timelapse") },
        { name: "can_view_livecam", label: "Access live camera", watch: watch("can_view_livecam") },
        { name: "can_view_aicamera", label: "Access AI camera", watch: watch("can_view_aicamera") },
    ];

    return (
        <Box sx={{ pb: 2 }}>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <RFG name="first_name" label="First Name" control={control}
                            rules={{
                                required: true, maxLength: 100,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid first name format",
                                }
                            }} className="mb-2">
                            <input autoComplete="off" placeholder="First name" />
                        </RFG>
                        <RFG name="last_name" label="Last name" control={control}
                            rules={{
                                required: true, maxLength: 100,
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Invalid last name format",
                                }
                            }} className="mb-2">
                            <input autoComplete="off" placeholder="Last name" />
                        </RFG>
                        <Box display={'flex'} gap={2}>
                            <Box minWidth={100}>
                                <RFG
                                    name="country_code"
                                    label="Phone Code"
                                    control={control}
                                    rules={{ required: true }}
                                //error={errors.country_code?.message}
                                >
                                    <CountrySelect
                                        defaultValue={defaultValues.country_code}
                                        labelKey="dial_code"
                                        valueKey="dial_code"
                                        //onValueChange={(country) => setValue("country_code", country.value)}
                                        onValueChange={(country) => {
                                            // Set and validate the same field name
                                            const value = country?.value || "";
                                            setValue("country_code", value, { shouldValidate: true });
                                            if (value) clearErrors("country_code");
                                            // no setError here; RHF required rule shows the message on submit
                                        }}
                                    />
                                </RFG>
                            </Box>
                            <Box width={1}>
                                <RFG
                                    name="phone"
                                    label="Phone"
                                    control={control}
                                    rules={{
                                        required: true,
                                        pattern: {
                                            value: /^[0-9]{5,15}$/,
                                            message: "Phone number must be between 5 and 15 digits",
                                        },
                                        maxLength: {
                                            value: 15,
                                            message: `Cannot exceed 15 digits`,
                                        }
                                    }}
                                >
                                    <input placeholder="e.g. 1234567890" autoComplete="off" />
                                </RFG>
                            </Box>
                        </Box>

                        <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
                            <select>
                                <option value="">Select Company</option>
                                {companies.map((company) => (
                                    <option key={company.id} value={company.id}>
                                        {company.company_name}
                                    </option>
                                ))}
                            </select>
                        </RFG>

                        <RFG name="project" label="Project Name" control={control} rules={{}} className="mb-2" error={errors.project?.message}>

                            <MultiSelect
                                //defaultValue={(defaultValues.project || projects).map((p) => p.id)} 
                                options={projects.map((project) => { return { id: project.id, label: project.project_name } })}
                                value={selectedProjects}
                                defaultValue={defaultValues.projects || []}
                                onValueChange={(value) => {
                                    setValue("project", value, { shouldValidate: false });
                                    if (value && value.length) clearErrors("project");
                                }}
                            />
                        </RFG>

                        <Box sx={{ my: 2 }} display="flex">
                            <RFG name="is_active" label="Active" control={control} className="mb-2">
                                <input
                                    type="checkbox"
                                    onChange={(e) => setValue("is_active", e.target.checked)}
                                    checked={isActive}
                                />
                            </RFG>
                        </Box>

                        <Box sx={{ my: 1 }} display="flex" flexWrap="wrap" gap={2}>
                            {booleanFields.map(({ name, label, watch }) => (
                                // <Box key={name} width="30%" display="flex">
                                <RFG name={name} label={label} control={control} className="mb-2">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => setValue(name, e.target.checked)}
                                        checked={watch}
                                    />
                                </RFG>
                                // </Box>
                            ))}
                        </Box>

                        {defaultValues.id && (
                            <Box textAlign="right" sx={{ my: 2 }}>
                                <Button
                                    onClick={() => setValue("action", "info")}
                                    className="btn-primary"
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </Box>
                        )}
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <RFG name="username" label="Username" control={control} rules={{
                            required: true, maxLength: 500,
                            pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                message: "Enter a valid email username",
                            }
                        }} className="mb-2">
                            <input autoComplete="off" placeholder="Username" />
                        </RFG>

                        <RFG
                            name="password"
                            label="Password"
                            control={control}
                            rules={{ required: !defaultValues.id, maxLength: 500 }}
                            className="mb-2"
                        >
                            <input type="password" autoComplete="off" placeholder="Password" />
                        </RFG>

                        <Box textAlign="right" sx={{ my: 4 }}>
                            <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                Back
                            </Button>
                            <Button
                                onClick={(e) => setValue("action", e.target.innerText)}
                                className="btn-primary"
                                type="submit"
                            >
                                {defaultValues.id ? "Change Password" : "Save"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
